module.exports = __webpack_public_path__ + "static/media/haaa_chandrabindu.20a62bec.ogg";